import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';

import { HotelData } from '@hiptraveler/data-access/api';
import { SearchResultDialogActionService } from '@hiptraveler/dialogs/search-result-dialog';
import { HotelsDataService } from '@hiptraveler/modules/search-page-root';
import { AppListenerService } from '@hiptraveler/common';
import { opacityFade, opacityFadeIn } from '@hiptraveler/animations';

@Component({
  selector: 'hotels',
  templateUrl: './hotels.component.html',
  viewProviders: [ HotelsDataService, SearchResultDialogActionService ],
  animations: [ opacityFade(), opacityFadeIn() ],
})
export class HotelsComponent implements OnInit {

  constructor(
    public service: HotelsDataService,
    private appListener: AppListenerService
  ) { }

  ngOnInit(): void {
    this.service.initializeDataAccess();
  }

  get skeletons$(): Observable<HotelData[]> {
    return this.appListener.clientWidth$.pipe(
      map((clientWidth: number) => clientWidth > 1400 ? Array(6).fill(0) : Array(4).fill(0))
    );
  }

}
